var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordianDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1274 0.490666C10.8033 -0.17218 11.8888 -0.161555 12.5516 0.514396L21.0388 9.16933C21.7017 9.84533 21.691 10.9307 21.015 11.5936C20.339 12.2565 19.2537 12.2459 18.5908 11.5699L11.3039 4.13888L3.87293 11.4258C3.19698 12.0887 2.11155 12.0781 1.4487 11.4021C0.785853 10.7261 0.796478 9.64069 1.47243 8.9778L10.1274 0.490666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordianDropdownArrow);
export default __webpack_public_path__ + "static/media/accordianDropdownArrow.5270579f442ce454947175717ceac67d.svg";
export { ForwardRef as ReactComponent };